import React, {useState, useEffect} from "react";

 

const Footer = () => {

  const [selectedEnvBase, setSelectedEnvBase] = useState()

    return (
      <footer
      className='footerbottom'
      >
            <div className="foter">
                <div className="foter-right">
                    <p>&copy; 2024, Turnkey Insights (I) Pvt. Ltd. </p>
                </div>
            </div>
        </footer>
);
};
  export default Footer;